import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { filter, map, pipe, switchMap, tap } from 'rxjs';

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  restoreSupportIconState,
  setUnreadMessagesCount,
  SupportState,
  ToggleSupportChat,
  ToggleSupportChatIcon,
} from '../../actions/actions';
import {
  isChatIconOpenSelector,
  isChatOpenSelector,
  isVisualGuideOpenSelector,
  selectSupportIconState,
  selectUnreadSupportMessagesCount,
} from '../../actions/selectors';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

import {
  GetSupportStatusGQL,
  SupportThreadUpdatedBySupportGQL,
} from 'ZalamoLibrary/src/lib/ui/support/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { VisualGuideManagerService } from '../../../visual-guide/visual-guide-manager.service';

@Component({
  selector: 'lib-support-icon-view',
  templateUrl: './support-icon-view.component.html',
  styleUrls: ['./support-icon-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SupportIconViewComponent extends AliveState implements OnInit {
  isChatOpen$ = this.store.pipe(select(isChatIconOpenSelector));
  isVisualGuideOpen$ = this.store.pipe(select(isVisualGuideOpenSelector));
  isChatWindowOpen$ = this.store.pipe(select(isChatOpenSelector));
  unreadMessagesCount$ = this.store.pipe(
    select(selectUnreadSupportMessagesCount),
  );

  supportStatus$ = this.organizationService.getCurrentOrganization().pipe(
    switchMap((organizationId) =>
      this.getSupportStatusGQL
        .watch({
          variables: {
            organizationId,
          },
        })
        .valueChanges.pipe(
          throwOnQueryError,
          filter(hasCompleteQueryData),
          map((result) => result.data['getZalamoSupportThread']),
        ),
    ),
  );

  visualGuidesCount$ = this.visualGuideManagerService.currentGuides$.pipe(
    map((guides) => guides.length),
  );

  constructor(
    private store: Store<{ support: { state: SupportState } }>,
    private getSupportStatusGQL: GetSupportStatusGQL,
    private organizationService: OrganizationService,
    private supportThreadUpdatedBySupportGQL: SupportThreadUpdatedBySupportGQL,
    private visualGuideManagerService: VisualGuideManagerService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (localStorage.supportIconState) {
      this.store.dispatch(
        restoreSupportIconState(JSON.parse(localStorage.supportIconState)),
      );
    }
    this.subscribeWhileAlive(
      this.supportStatus$.pipe(
        tap((status) => {
          if (status.unreadCount > 0) {
            this.store.dispatch(
              setUnreadMessagesCount({ count: status.unreadCount }),
            );
            this.store.dispatch(ToggleSupportChatIcon({ force: true }));
          }
        }),
        filter(({ supportThreadId }) => !!supportThreadId),
        switchMap(({ supportThreadId }) =>
          this.supportThreadUpdatedBySupportGQL.subscribe({
            variables: { supportThreadId },
          }),
        ),
      ),
      this.store.pipe(
        select(selectSupportIconState),
        tap(
          (currentState) =>
            (localStorage.supportIconState = JSON.stringify(currentState)),
        ),
      ),
    );
  }

  showSupport(show) {
    console.log('SHOW SUPPORT', show);
    if (show === 'chat') {
      this.store.dispatch(ToggleSupportChat({}));
      this.store.dispatch(ToggleSupportChatIcon({ force: true }));
    }
  }
}
